import "@mdxeditor/editor/style.css";

import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CreateLink,
  ListsToggle,
  MDXEditor,
  UndoRedo,
  headingsPlugin,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  toolbarPlugin,
} from "@mdxeditor/editor";

const MarkdownEditor = ({ data }) => {
  const { value = "", onChange } = data;

  // Show New Markdown Editor
  const isMobile = window.innerWidth < 800;

  let plugins = [
    headingsPlugin(),
    linkPlugin(),
    linkDialogPlugin(),
    listsPlugin(),
  ];

  if (!data.disabled) {
    plugins = [
      ...plugins,
      toolbarPlugin({
        toolbarContents: () => (
          <>
            <UndoRedo />
            <BoldItalicUnderlineToggles />
            <CreateLink />
            {!isMobile && <ListsToggle />}
            {!isMobile && <BlockTypeSelect />}
          </>
        ),
      }),
    ];
  }

  return (
    <MDXEditor
      markdown={value || ""}
      onChange={onChange}
      readOnly={data.disabled}
      plugins={plugins}
    />
  );
};

export default MarkdownEditor;
